import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Convert from './pages/Convert';
import ConvertDetail from './pages/ConvertDetail';
import BuyAirtime from './pages/BuyAirtime';
import AirtimeDetail from './pages/AirtimeDetail';
import ScratchCard from './components/ScratchCard';
import Contact from './pages/Contact';
import './App.css';

function App() {

  return (
    <Router>
      <div className="App">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/convert" element={<Convert />} />
            <Route path="/convert/:type" element={<ConvertDetail />} />
	   <Route path="/scratch-card" element={<ScratchCard />} />
            <Route path="/buy-airtime" element={<BuyAirtime />} />
            <Route path="/buy-airtime/:provider" element={<AirtimeDetail />} />
            <Route path="/contact" element={<Contact />} />
	  
            <Route path="/bundles" element={<bundles />} /> {/* Placeholder for download page */}
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
